import { QuizList } from './QuizList';

export default {
    list: QuizList,
};
